import { render, staticRenderFns } from "./EditDAppComponent.vue?vue&type=template&id=4f21cfbe&"
import script from "./EditDAppComponent.vue?vue&type=script&lang=js&"
export * from "./EditDAppComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditDAppComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports